import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { User, UserBeneficiary } from '@app/models';

import { BiometricService, UserService } from '@app/services';
import { ModalService } from '@app/services/modal/modal.service';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';

declare var cordova: any;

@Component({
  templateUrl: './modal-add-beneficiary.component.html',
  styleUrls: ['./modal-add-beneficiary.component.scss']
})
export class ModalAddBeneficiaryComponent implements OnInit {
  beneficiaryForm: UntypedFormGroup;
  limit = 100;
  benef: { id: string, name: string; curp: string; percent: number; address: string };
  isUpdate = false;

  headerTxt = 'Agregar beneficiario';
  btnTxt = 'Agregar';
  placeholderPercent: number | string;

  trash = faTrashAlt;

  // Variable global para almacenar el MoNIP
  moNip: any;

  user: User;
  platformType: 'ios' | 'android' | 'web' = 'web';
  isNativePlatform: boolean = false;

  constructor(
    private fb: UntypedFormBuilder,
    private dialog: MatDialogRef<ModalAddBeneficiaryComponent, UserBeneficiary>,
    private userServ: UserService,
    private modal: ModalService,
    private toastServ: ToastrService,
    private biometricServ: BiometricService) {
      this.platformType = typeof cordova !== 'undefined' ? 'ios' : 'web';
    }

  ngOnInit(): void {

    this.isNativePlatform = this.platformType === 'ios' || this.platformType === 'android';

    // Cargar información del usuario para verificar si cuenta con MoNIP 
    this.userServ.getUserInf().subscribe((r: any) => {
      this.moNip = r.nip;
      this.user = r;
    })

    this.isUpdate = !!this.benef;

    if (this.isUpdate) {
      this.headerTxt = 'Modificar porciento';
      this.btnTxt = 'Modificar';
    }

    this.placeholderPercent = this.benef?.percent || 'Ej: 100';

    this.beneficiaryForm = this.fb.group({
      name: [{ disabled: this.isUpdate, value: this.benef?.name || '' }, Validators.compose([Validators.required, Validators.minLength(10)])],
      curp: [{ disabled: this.isUpdate, value: this.benef?.curp ? `${this.benef.curp}` : '' }, Validators.compose([Validators.minLength(18), Validators.maxLength(18)])],
      percent: [this.isUpdate ? this.benef.percent : this.limit, Validators.compose([Validators.max(this.limit), Validators.min(1)])],
      address: [{ disabled: this.isUpdate, value: this.benef?.address || '' }, Validators.compose([Validators.required])],
    });
  }


  async addBeneficiary() {
      if (this.beneficiaryForm.valid) {
        if(!this.isNativePlatform) {
          const pwdModal = this.modal.openModalVerifyPassword(this.user?.email);

          pwdModal.beforeClosed().subscribe(pwd => {
            if (pwd) {
              if (this.isUpdate) {
                const { percent } = this.beneficiaryForm.value;
                this.userServ.updateBeneficiary(this.benef.id, percent).subscribe(b => {
                  this.toastServ.success('Beneficiario actualizado con éxito'), this.dialog.close(b), () => this.dialog.close()
                });
              } else {
                const { name, curp, percent, address } = this.beneficiaryForm.value;
                //this.userServ.addBeneficiary({ name, curp, percent, address }).subscribe(b => {
                //  this.toastServ.success('Beneficiario agregado con éxito'), this.dialog.close(b), () => this.dialog.close() });
              }
            }
          });
        } else {
          this.biometricServ.validateBiometrics().then(isAuthenticated => {
            if (isAuthenticated) {
              if (this.isUpdate) {
                const { percent } = this.beneficiaryForm.value;
                this.userServ.updateBeneficiary(this.benef.id, percent).subscribe(b => {
                  this.toastServ.success('Beneficiario actualizado con éxito');
                  this.dialog.close(b);
                }, 
                () => this.dialog.close());
              } else {
                const { name, curp, percent, address } = this.beneficiaryForm.value;
                //this.userServ.addBeneficiary({ name, curp, percent, address }).subscribe(b => {
                //  this.toastServ.success('Beneficiario agregado con éxito');
                //  this.dialog.close(b);
                //}, 
                //() => this.dialog.close());
              }
            } else {
              this.toastServ.warning('No se pudo verificar tu identidad, por favor intenta de nuevo');
            }
          });          
        }
      } else {
        this.toastServ.info('Por favor, llena todos los campos para actualizar la información');
      }
  }

  deleteBeneficiary() {
    if (this.beneficiaryForm.valid) {
      if(!this.isNativePlatform) {
        const modalPwd = this.modal.openModalVerifyPassword(this.user?.email);

        modalPwd.beforeClosed().subscribe(pwd => {
          if (pwd) {
            //this.userServ.deleteBeneficiary(this.benef.id)
            //  .subscribe(() => { this.toastServ.success('Beneficiario eliminado con éxito'), this.dialog.close({ id: this.benef.id, percent: 0, delete: true }), () => this.dialog.close()});
          } else {
            this.toastServ.warning('Por favor, ingresa tu contraseña para eliminar el beneficiario');
          }
        });
      } else {
        this.biometricServ.validateBiometrics().then(isAuthenticated => {
          if (isAuthenticated) {
            //this.userServ.deleteBeneficiary(this.benef.id)
            //  .subscribe(() => { 
            //    this.toastServ.success('Beneficiario eliminado con éxito'); 
            //    this.dialog.close({ id: this.benef.id, percent: 0, delete: true });
            //  }, 
            //  () => this.dialog.close());
          } else {
            this.toastServ.warning('No se pudo verificar tu identidad, por favor intenta de nuevo');
          }
        });
        
      }
    } else {
      this.dialog.close();
    }
  }
}
